{
  "controls": {
    "back": "Voltar",
    "close": "Fechar",
    "last": "Pronto",
    "next": "Próximo",
    "skip": "Pular tour"
  },
  "dashboard": {
    "greeting": {
      "title": "Bem-vindo ao seu dashboard",
      "body": "Esta é sua página inicial — uma visão rápida de oportunidades, snipes e seus principais reinos."
    },
    "kpi": {
      "title": "Oportunidades em tempo real",
      "body": "Quantos flips lucrativos estão disponíveis agora em todas as ferramentas."
    },
    "topOpportunities": {
      "title": "Melhores oportunidades",
      "body": "Prévia ao vivo dos melhores flips. Troque de aba para ver itens de venda rápida ou melhores compras."
    },
    "snipeAlerts": {
      "title": "Snipes recentes",
      "body": "Alertas de snipe disparados no último ciclo de atualização. Clique para configurar novos alertas."
    },
    "realmStats": {
      "title": "Reinos top",
      "body": "Seus reinos de venda mais fortes ordenados por população, leilões ou relação de preço."
    },
    "quickActions": {
      "title": "Acesso rápido",
      "body": "Vá direto para qualquer ferramenta a partir daqui."
    }
  },
  "flipping": {
    "dataFreshness": {
      "title": "Status dos dados",
      "body": "Mostra o quanto os dados de leilão estão atualizados. A página recarrega sozinha quando novos dados chegam."
    },
    "filters": {
      "title": "Barra de filtros",
      "body": "Filtre resultados por reino, qualidade, lucro, taxa de venda e mais. Salve suas combinações favoritas como presets."
    },
    "stats": {
      "title": "Resumo de investimento",
      "body": "Totais dos flips visíveis: investimento necessário, receita esperada e lucro após a taxa da casa de leilões."
    },
    "table": {
      "title": "Oportunidades",
      "body": "Cada linha é um flip: compre em um reino, venda em outro. Clique no item para copiar ou favoritar."
    },
    "pagination": {
      "title": "Paginação",
      "body": "Navegue entre páginas e escolha quantos itens mostrar por vez."
    }
  },
  "housing": {
    "dataFreshness": {
      "title": "Status dos dados",
      "body": "Mostra o quanto os dados de housing estão atualizados e quando chega a próxima atualização."
    },
    "filters": {
      "title": "Barra de filtros",
      "body": "Filtre flips de housing por reino, lucro, taxa de venda e teto de buyout."
    },
    "stats": {
      "title": "Resumo de investimento",
      "body": "Totais dos flips de housing visíveis para você planejar o orçamento antes de comprar."
    },
    "table": {
      "title": "Oportunidades de housing",
      "body": "Cada linha é um item de housing barato em um reino e mais valioso em outro."
    },
    "pagination": {
      "title": "Paginação",
      "body": "Navegue entre páginas e ajuste quantos resultados mostrar."
    }
  },
  "dropship": {
    "dataFreshness": {
      "title": "Status dos dados",
      "body": "Mostra o quanto os dados de dropship estão atualizados e quando chega a próxima atualização."
    },
    "filters": {
      "title": "Barra de filtros",
      "body": "Filtre oportunidades de dropship por reino, qualidade, expansão e rentabilidade."
    },
    "stats": {
      "title": "Resumo de investimento",
      "body": "Totais dos trades de dropship visíveis — útil para planejar capital e capacidade."
    },
    "table": {
      "title": "Oportunidades de dropship",
      "body": "Cada linha é um item para comprar em um reino e revender em outro com margem."
    },
    "pagination": {
      "title": "Paginação",
      "body": "Navegue entre páginas de resultados de dropship."
    }
  },
  "inventory": {
    "realms": {
      "title": "Reinos de venda",
      "body": "Escolha os reinos contra os quais quer analisar seu inventário."
    },
    "csv": {
      "title": "Cole seu inventário",
      "body": "Cole aqui um CSV do seu estoque separado por ponto e vírgula — a ferramenta vai buscar trades cross-realm lucrativos."
    },
    "analyze": {
      "title": "Analisar",
      "body": "Rode a análise cross-realm sobre o inventário que você acabou de colar."
    },
    "results": {
      "title": "Sugestões de flip",
      "body": "Cada linha é um item do seu inventário que agora vale mais em outro reino."
    },
    "export": {
      "title": "Exportar",
      "body": "Baixe a análise como CSV para usar em planilha ou addon."
    }
  },
  "stats": {
    "table": {
      "title": "Estatísticas de reino",
      "body": "Compare preços de leilão, quantidade de anúncios e tendências em todos os reinos da sua região."
    }
  },
  "tsm": {
    "filters": {
      "title": "Filtros",
      "body": "Escolha quais itens incluir por categoria, expansão, qualidade e lucro."
    },
    "table": {
      "title": "Lista de itens",
      "body": "Itens que casam com seus filtros — copie direto em uma operação de TSM Price Source."
    },
    "pagination": {
      "title": "Paginação",
      "body": "Navegue entre páginas e escolha quantos itens mostrar por vez."
    }
  },
  "snipe": {
    "tabs": {
      "title": "Categorias de alerta",
      "body": "Alterne entre snipes de itens, snipes de pets, o token do WoW e regras de nível de item."
    },
    "add": {
      "title": "Adicionar novo alerta",
      "body": "Adicione um item, pet ou regra à sua lista — você será avisado assim que cair abaixo do preço-alvo."
    },
    "list": {
      "title": "Alertas ativos",
      "body": "Seus alertas configurados com preços-alvo e canais de webhook atribuídos."
    },
    "import": {
      "title": "Importação em massa",
      "body": "Importe uma lista inteira de uma vez: clique em Importar para escolher um arquivo, ou simplesmente cole uma lista copiada em qualquer lugar desta página. Você verá uma prévia antes de qualquer coisa ser salva."
    },
    "inlineEdit": {
      "title": "Edite preços na hora",
      "body": "Clique em qualquer preço da tabela para editá-lo ali mesmo — Enter salva, Esc cancela. Alertas excluídos podem ser restaurados com Desfazer, e você pode ordenar a lista por nome ou preço."
    }
  },
  "tsmProfile": {
    "video": {
      "title": "Vídeo de configuração",
      "body": "Veja este vídeo curto com o passo a passo completo de configuração do perfil TSM."
    },
    "min": {
      "title": "Preço mínimo",
      "body": "Copie esta fórmula para a sua operação de preço mínimo do TSM."
    },
    "max": {
      "title": "Preço máximo",
      "body": "Copie esta fórmula para a sua operação de preço máximo do TSM."
    },
    "normal": {
      "title": "Preço normal",
      "body": "Copie esta fórmula para a sua operação de preço normal do TSM."
    }
  },
  "settingsRealm": {
    "region": {
      "title": "Região",
      "body": "Escolha US ou EU — isso comanda todas as listas de reinos do app."
    },
    "buying": {
      "title": "Reinos de compra",
      "body": "Os reinos onde você compra barato. Adicione tantos quanto puder visitar com facilidade."
    },
    "selling": {
      "title": "Reinos de venda",
      "body": "Os reinos onde você revende com lucro. Eles aparecem como destino em todas as ferramentas."
    },
    "accounts": {
      "title": "Contas de WoW",
      "body": "Se você joga com várias contas, registre-as aqui e atribua reinos a cada uma."
    },
    "save": {
      "title": "Salvar configuração",
      "body": "Salve e o resto do app já passa a usar esses reinos."
    }
  },
  "settingsPersonal": {
    "preview": {
      "title": "Prévia dos filtros",
      "body": "Uma prévia ao vivo da interface de filtros que você vê nas ferramentas de flipping."
    },
    "ranges": {
      "title": "Faixas padrão",
      "body": "Defina as faixas de lucro, taxa de venda e preço pré-aplicadas em cada ferramenta."
    },
    "dashboard": {
      "title": "Limites do dashboard",
      "body": "Controle o buyout mín. e máx. das oportunidades exibidas no seu dashboard."
    },
    "matching": {
      "title": "Match de itens",
      "body": "Restrinja o match de atributos a certas expansões para preços cross-realm mais precisos."
    },
    "save": {
      "title": "Salvar padrões",
      "body": "Salve estas configurações como seus padrões pessoais em todas as ferramentas."
    }
  },
  "rowActions": {
    "title": "Menu de ações da linha",
    "body": "A primeira coluna agora agrupa a estrela de favorito, a caixa de seleção e o sino de alerta de snipe. Abra este menu para selecionar ou desselecionar a página atual ou tudo em todas as páginas, manter apenas seus favoritos, ou fixar no topo favoritos, alvos de snipe e linhas selecionadas. As configurações de colunas (reordenar arrastando e mostrar/ocultar) também ficam aqui."
  },
  "settingsDiscord": {
    "link": {
      "title": "Vincular Discord",
      "body": "Conecte sua conta do Discord para que o bot possa te mandar alertas e notificações."
    },
    "verification": {
      "title": "Verificar DMs",
      "body": "Receba um código de 6 dígitos para confirmar que o bot consegue te mandar DM."
    },
    "notifications": {
      "title": "Configurações de notificação",
      "body": "Ative notificações por DM para atualizações de região e outros eventos."
    },
    "webhooks": {
      "title": "Categorias de webhook",
      "body": "Crie categorias de webhook para mandar alertas de snipe para canais específicos do Discord."
    }
  },
  "classicDeals": {
    "controls": {
      "title": "Classic Deals",
      "body": "Pick your region and realms, then find same-realm undercut opportunities."
    },
    "table": {
      "title": "Deals",
      "body": "Each row is an item you can buy at the lowest price and relist just under the next-cheapest listing on the same realm."
    }
  },
  "filterMode": {
    "title": "Filtrar ou recalcular",
    "body": "Escolha o que acontece ao mudar um filtro: «Filtrar» refina na hora os resultados já carregados e «Recalcular» busca resultados novos no servidor."
  }
}
